import * as React from 'react';

import { cn } from '@/lib/utils';

function TypographyH2({ className, ...props }: React.ComponentProps<'h2'>) {
    return (
        <h2 data-slot="typography-h2" className={cn('text-2xl font-semibold tracking-tight', className)} {...props} />
    );
}

function TypographyH3({ className, ...props }: React.ComponentProps<'h3'>) {
    return (
        <h3
            data-slot="typography-h3"
            className={cn('text-lg leading-none font-semibold tracking-tight', className)}
            {...props}
        />
    );
}

function TypographyH4({ className, ...props }: React.ComponentProps<'h4'>) {
    return <h4 data-slot="typography-h4" className={cn('text-sm leading-none font-semibold', className)} {...props} />;
}

function TypographyP({ className, ...props }: React.ComponentProps<'p'>) {
    return <p data-slot="typography-p" className={cn('text-sm', className)} {...props} />;
}

function TypographySmall({ className, ...props }: React.ComponentProps<'span'>) {
    return <span data-slot="typography-small" className={cn('text-sm', className)} {...props} />;
}

function TypographyMuted({ className, ...props }: React.ComponentProps<'span'>) {
    return <span data-slot="typography-muted" className={cn('text-muted-foreground text-sm', className)} {...props} />;
}

export { TypographyH2, TypographyH3, TypographyH4, TypographyMuted, TypographyP, TypographySmall };
